<template>
  <v-container>
    <h2>This page can't be found.</h2>
    <div></div>
    <br/>
    <!-- <p>Hmm, I knew I put that page somewhere here...</p> -->
    <p v-if="previous"><a :href="previous.path">Return to previous page</a></p>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    title: "Page not found",
    previous: null
  }),
  beforeRouteEnter(to, from, next) {
    next(vm => { vm.previous = from })
  }
};
</script>
